import View from './view.js'
import { isSameDay } from 'date-fns'

function isSelected(rangeTemplate, currentValue) {
  return (
    isSameDay(rangeTemplate?.from, currentValue?.from) &&
    isSameDay(rangeTemplate?.to, currentValue?.to)
  )
}

export default function Logic(props) {
  return (
    <View
      {...props}
      isSelected={isSelected(props.item, props.currentValue)}
      onClick={() =>
        props.onChange &&
        props.onChange({
          from: props.item.from,
          to: props.item.to,
        })
      }
    />
  )
}
